// 全局枚举
export const ENUM_YES_NO = {
  YES: 1,
  NO: 0
}
